<script setup lang="ts">
  import { RouterView } from 'vue-router';
</script>

<template>
  <RouterView />
</template>

<!-- eslint-disable-next-line vue/enforce-style-attribute -->
<style lang="scss">
  :root {
    font-family: var(--custom-font-family, Raleway), sans-serif, ui-sans-serif;
    font-size: var(--custom-font-size);
    color-scheme: normal !important;
  }
  @media (forced-colors: active) {
    span[class^='i-material-symbols'] {
      background-color: ButtonText !important;
    }
    span[class*=' i-material-symbols'] {
      background-color: ButtonText !important;
    }
  }
</style>
